module.exports = __webpack_public_path__ + "img/head.a8e52b87.png";